import React, { useEffect, useState } from "react";
// import logo from "../assets/img/logo.png";
import logo from "../assetsWeb/images/logoNew.png";

import mainLogo from "../assets/img/main-logo 1.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { userLogin, userLogout } from "../actions/authActions";
const LoginPage = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const navigateUser = () => {
    navigate("/dashboard");
  };
  const locationUrl = useLocation();
  const queryParams = new URLSearchParams(locationUrl.search);
  const returnUrl = queryParams.get("returnUrl");

  // const navigateUser = () => {
  //   navigate("/login");
  // };

  const chkUser = async () => {
    if (auth.user.disable === true || auth.user.isDriver === true) {
      dispatch(
        userLogout({ refreshToken: auth.tokens.refresh.token }, navigateUser)
      );
    }
    // else {
    //   dispatch(getUserByToken(auth?.tokens?.refresh?.token, navigate, auth));
    // }
  };
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // if (localStorage.tokens === undefined){
    //     console.log("empty")
    // }
    // else {
    //     chkUser()
    // }
    if (auth?.tokens?.refresh?.token && auth?.user) {
      chkUser();
    }
  }, []);
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // console.log(windowSize)
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  const userData = {
    email: values.email,
    password: values.password,
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // dispatch(userLogin(userData, navigateUser))

    dispatch(userLogin(userData, navigate, returnUrl));
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const signUpUrl = () => {
    navigate(`/sign-up${returnUrl ? "?returnUrl=" + returnUrl : ""}`);
  };
  return (
    <>
      <div className="login-section" style={{ backgroundColor: "#28B8EC" }}>
        <div className="container">
          <div
            className="row align-items-center justify-content-center"
            style={{ height: "100vh" }}
          >
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="login-card">
                <div className="loginlogo mb-3">
                  <a href="/login">
                    <img className="img-login" src={logo} alt="" />
                  </a>
                </div>
                <form
                  onSubmit={handleSubmit}
                  action=""
                  autocomplete="off"
                  className="row p-4 pt-0"
                >
                  <div className="col-md-12">
                    <label for="#" className="form-label">
                      Username/Email
                    </label>
                    <div className="input-group mb-3 ">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          id="basic-addon1"
                          style={{ height: "40px" }}
                        >
                          <i className="fa fa-envelope m-1"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        value={values.email}
                        onChange={handleChange("email")}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label for="#" className="form-label">
                      Password
                    </label>
                    <div className="input-group mb-3 ">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          id="basic-addon2"
                          style={{ height: "40px" }}
                        >
                          <i className="fa fa-lock m-1"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        className="form-control"
                        placeholder=""
                        aria-label="password"
                        aria-describedby="basic-addon2"
                        value={values.password}
                        onChange={handleChange("password")}
                        required
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer", height: "40px" }}
                        >
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            } m-1`}
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="form-check d-flex align-items-center mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label
                          className="form-check-label ms-2 mb-0"
                          htmlFor="flexCheckDefault"
                          style={{ marginTop: "1px" }}
                        >
                          Remember Me
                        </label>
                      </div>
                      <div>
                        <a href="#" className="forgetlink">
                          Forget Password
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="d-grid mb-3">
                      <button
                        // href="/login"
                        type="submit"
                        id="sendlogin"
                        className="btn btn-blue rounded-1"
                      >
                        Login
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12 p-0">
                    <div className="bglogo pt-2 pb-2">
                      <p className="mb-2">
                        Don't have an Account?
                        <strong
                          style={{ color: "#28B8EC", cursor: "pointer" }}
                          onClick={signUpUrl}
                        >
                          {" "}
                          Sign Up
                        </strong>
                      </p>
                      <p className="form-label">
                        By logging in, you agree to our <br />
                        <strong>Terms and Conditions</strong>
                      </p>
                      {/* <a href="/https://iconictek.com/">
                        <img src={mainLogo} alt="" />
                      </a> */}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginPage;
